import types from '../../../types';

export default {
  [types.STORE_INVOICES]: (state, payload) => {
    state.items = [...state.items, ...payload.items];
    state.count = payload.count;
    state.entity = payload.entity;
  },
  [types.STORE_INVOICE]: (state, payload) => {
    state.invoice = payload;
  },
  [types.CLEAR_INVOICES]: (state) => {
    state.items = [];
  },
  [types.CLEAR_INVOICE]: (state) => {
    state.invoice = {};
  },
};
